import { jsx as _jsx } from "react/jsx-runtime";
import { convertFromRaw, Editor, EditorState, } from "draft-js";
import { blockRenderMap } from "../rich-text-editor/blockRenderMap.js";
export const LabeledRichTextValue = ({ content, placeholder }) => {
    const editorState = content
        ? EditorState.createWithContent(convertFromRaw(content))
        : EditorState.createEmpty();
    const contentState = editorState.getCurrentContent();
    return (_jsx(Editor, { editorState: editorState, placeholder: 
        // If the user changes block type before entering any text, we can
        // either style the placeholder or hide it. Let's just hide it now.
        contentState.hasText() ||
            contentState.getBlockMap().first().getType() !== "unstyled"
            ? undefined
            : placeholder, readOnly: true, onChange: () => { }, blockRenderMap: blockRenderMap }));
};
//# sourceMappingURL=LabeledRichTextValue.js.map